// Prints opened with photos whose upload never ended : the prints are already removed (see
// PrintRepository.lostPhotoPrints), this only tells the customer why and what to do.
fx.ns("shared.popups", class LostPhotosPrints extends shared.popups.BasePersonPopup{

    constructor(data, count)
    {
        super(data, fx.get("assets").personNotHappy );

        this.count = count;

        this.contentWidth = 550;
        this.contentHeight = 250;
    }

    create()
    {
        super.create();

        let title = this.count > 1 ? fx.text("$ photos n'ont pu être envoyées", this.count) : fx.text("1 photo n'a pu être envoyée");

        this.addChild(new fx.components.Text({text:title, className:"title center"}));
        this.addChild(new fx.components.Text({text:fx.text("L'envoi n'était pas terminé quand la page a été fermée, j'ai donc retiré les tirages concernés. Ajoutez à nouveau vos photos, et gardez cette page ouverte jusqu'à la fin de l'envoi."), className:"text center"}));

        this.addFooterChild("close");
    }
});
